module.exports = __webpack_public_path__ + "static/media/LemonBeer.eb9a9d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/IoT/LemonBeer.png
// module id = 474
// module chunks = 0